
import Vue, { PropType } from 'vue';
import { get } from 'lodash';
import Api from '@/core/api';
import { Unsubscriber } from '@/core/event-bus';
import { LevelDetails, PlayerState } from '@/core/player-state';
import IconButtonWithDropdown from '@/common/icon-button-with-dropdown/IconButtonWithDropdown.vue';
import VideoPlayerMenu from '@/common/video-player-menu/VideoPlayerMenu.vue';
import { Icon } from '@/common/icon/Icon.vue';

interface MenuItem {
    id: number,
    value: string,
}

function getLevelName(level: LevelDetails): string {
    return `${level.width}x${level.height}`;
}

export default Vue.extend({
    components: {
        IconButtonWithDropdown,
        VideoPlayerMenu
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    data() {
        return {
            unsubscribers: [] as Unsubscriber[],
            levelsAvailable: [] as LevelDetails[],
            currentLevel: null as LevelDetails | null
        };
    },

    computed: {

        icon(): Icon {
            return Icon.settings;
        },

        resolutionMenuItems(): MenuItem[] {
            const menuItems: MenuItem[] = [{
                id: -1,
                value: 'Auto',
            }];

            for (let i = 0;i < this.levelsAvailable.length;i++) {
                const level = this.levelsAvailable[i];
                menuItems.push({
                    id: i,
                    value: getLevelName(level),
                });
            }

            return menuItems;
        },

        selectedLevel(): MenuItem | null {
            if (!this.currentLevel) {
                return null;
            }

            const matchingItem = this.resolutionMenuItems.find((item) => item.value === this.currentLevel?.resolution);

            return {
                id: matchingItem?.id as number,
                value: this.currentLevel?.resolution as string,
            };
        },

        showControl(): boolean {
            return this.levelsAvailable.length > 1;
        }
    },

    mounted() {
        const { unsubscriber, state } = this.api.onStateChange(
            (partial: Partial<PlayerState>) => {
                this.updateState(partial);
            }
        );

        this.updateState(state);

        this.unsubscribers.push(unsubscriber);
    },


    beforeDestroy() {
        for (const unsubscriber of this.unsubscribers) {
            if (typeof unsubscriber === 'function') {
                unsubscriber();
            }
        }
    },

    methods: {
        updateState(state: Partial<PlayerState>) {
            this.levelsAvailable = get(state, 'levelsAvailable', this.levelsAvailable);
            this.currentLevel = get(state, 'currentLevel', this.currentLevel);
        },

        onLevelSelected(item: MenuItem) {
            this.api.selectLevel(item.id);
        },
    }
});
